import {AfterViewInit, Component} from '@angular/core';
import {
    ControlService,
    IconService,
    SubtitlesService
} from "../../../core";
import {MenuType} from "../../../models";

@Component({
    selector: 'data-table',
    templateUrl: './data-table.component.html',
    styleUrls: ['./data-table.component.scss']
})
export class DataTableComponent implements AfterViewInit {
    constructor(
        public control: ControlService,
        private icon: IconService,
        private subtitles: SubtitlesService,
    ) {
    }

    ngAfterViewInit() {
        this.control.setOverflow();
    }

    setIcon(val: number | MenuType): string {
        if (val === null) return;

        return this.icon.setIcon(val);
    }

    subtitle(val: number): string {
        return val !== 0 ? this.subtitles.setSubtitle(val) : '';
    }
}
